"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowPowerModeMsg = exports.ERRORS = void 0;
exports.playOncePossible = playOncePossible;
exports.isBitrateLayer = isBitrateLayer;
exports.getBitrateLayersFromQualities = getBitrateLayersFromQualities;
exports.sortEncodings = sortEncodings;
exports.encodingToLayer = encodingToLayer;
exports.fetchManifestQualities = fetchManifestQualities;
exports.isFatalError = isFatalError;
exports.findClosestQuality = findClosestQuality;
exports.equalQualities = equalQualities;
exports.dataProperties = dataProperties;
exports.isInLowPowerMode = isInLowPowerMode;
exports.attachVideoElement = attachVideoElement;
const adapter_1 = require("../../api/adapter");
const bitrate_switching_1 = require("../../api/player/features/bitrate-switching");
const hlsjs_1 = require("./hlsjs");
const native_hls_1 = require("./native-hls");
// disabled because causes the bug with black screen
//
// type VideoMetadata = {
//   timeout: number;
// };
//
// const meta = new WeakMap<VideoElement, VideoMetadata>();
// a workaround for mediasoup3 bug when
// ms3 creates consumer in an invalid statexw
// if remote track was disabled at start
// function fixMS3ServerBug(el: VideoElement): void {
//   const src = el.srcObject;
//   if (typeof src === "object" && src != null && "getTracks" in src) {
//     const stream = el.srcObject as MediaStream;
//     stream.getTracks().forEach((tr) => {
//       // if muted and enabled are true then it means
//       // this track is enabled but it didn't get any frames yet
//       // so if we didn't get any frames for 5000 ms that means
//       // it was disabled in remote producer
//       if (tr.muted && tr.enabled) {
//         // so disable it (as it should be at start)
//         // and trigger loading again
//         tr.enabled = false;
//       }
//     });
//   }
//
//   if (el.load != null) {
//     el.load();
//   } else {
//     el.play();
//   }
// }
function playOncePossible(el, logger) {
    logger.debug("playOncePossible()", { aggregates: el.dumpVideoElement() });
    if (!el.paused && !el.ended) {
        return Promise.resolve();
    }
    if (el.readyState > 2) {
        return el.play();
    }
    // device.clearTimeout(meta.get(el)?.timeout);
    // const fixMS3Timeout = device.setTimeout(fixMS3ServerBug.bind(null, el), 5000);
    // meta.set(el, { timeout: fixMS3Timeout });
    return new Promise((resolve, reject) => {
        logger.debug("playOncePossible() returned Promise", { aggregates: el.dumpVideoElement() });
        const onReady = () => {
            if (el.readyState > 2) {
                // device.clearTimeout(fixMS3Timeout);
                el.removeListener("loadeddata", onReady);
                el.play()
                    .catch(reject)
                    .then(() => {
                    if (!el.paused) {
                        resolve();
                        return;
                    }
                    // if it's still paused then we'll check
                    // this status for ~1sec every 50ms
                    let attempts = 20;
                    const n = adapter_1.device.setInterval(() => {
                        if (!el.paused) {
                            adapter_1.device.clearInterval(n);
                            resolve();
                        }
                        if (--attempts === 0) {
                            adapter_1.device.clearInterval(n);
                            reject(new Error("Video element remains paused for 1s after play() call"));
                        }
                    }, 50);
                });
            }
        };
        el.addListener("loadeddata", onReady);
    });
}
function isBitrateLayer(obj) {
    return "id" in obj && "bitrate" in obj && "isSource" in obj;
}
function getBitrateLayersFromQualities(qualities) {
    function notEmpty(value) {
        return value != null && value !== undefined;
    }
    return qualities.map((q) => q.layer).filter(notEmpty);
}
function sortEncodings(encodings) {
    return [...encodings].sort((a, b) => {
        var _a, _b, _c, _d, _e, _f;
        const aBitrate = isBitrateLayer(a) ? (_a = a.bitrate) !== null && _a !== void 0 ? _a : a.maxBitrate : ((_b = a.audioKbps) !== null && _b !== void 0 ? _b : 0) + ((_c = a.videoKbps) !== null && _c !== void 0 ? _c : 0);
        const bBitrate = isBitrateLayer(b) ? (_d = b.bitrate) !== null && _d !== void 0 ? _d : b.maxBitrate : ((_e = b.audioKbps) !== null && _e !== void 0 ? _e : 0) + ((_f = b.videoKbps) !== null && _f !== void 0 ? _f : 0);
        // that means we don't know bitrate so assume
        // it's the source with the highest bitrate
        if (aBitrate === 0) {
            return -1;
        }
        return bBitrate - aBitrate;
    });
}
function encodingToLayer(encoding) {
    var _a, _b, _c, _d, _e;
    if (isBitrateLayer(encoding)) {
        return {
            id: encoding.id,
            bitrate: (_a = encoding.bitrate) !== null && _a !== void 0 ? _a : encoding.maxBitrate,
            isSource: (_b = encoding.isSource) !== null && _b !== void 0 ? _b : false,
            appData: (_c = encoding.appData) !== null && _c !== void 0 ? _c : {},
        };
    }
    const layer = {
        id: encoding.location,
        bitrate: ((_d = encoding.audioKbps) !== null && _d !== void 0 ? _d : 0) + ((_e = encoding.videoKbps) !== null && _e !== void 0 ? _e : 0),
        isSource: false,
        appData: {},
        encoding,
    };
    if (layer.appData != null && encoding.videoWidth && encoding.videoHeight) {
        layer.appData.videoWidth = encoding.videoWidth;
        layer.appData.videoHeight = encoding.videoHeight;
    }
    return layer;
}
function fetchManifestQualities(format, origin, player) {
    let encodings;
    if (Array.isArray(format)) {
        // that comes from SFU
        encodings = format;
    }
    else if (format.substitute != null) {
        // that comes from manifest
        // if it has substitute then the stream is blurred
        // so we just won't provide any real encodings
        encodings = [format.substitute];
    }
    else {
        encodings = format.encodings;
    }
    const enc = sortEncodings(encodings !== null && encodings !== void 0 ? encodings : []);
    const qty = [];
    if (origin != null) {
        qty.push({
            level: bitrate_switching_1.SourceScoreLevel.High,
            layer: { bitrate: 0, isSource: true, id: origin },
        });
    }
    else {
        const sourceLayers = enc.map((e) => encodingToLayer(e)).filter((e) => e.isSource);
        sourceLayers.sort((a, b) => (a.bitrate > b.bitrate ? 1 : -1));
        for (let i = 0; i < sourceLayers.length; i++) {
            switch (i) {
                case 0:
                    qty.push({ level: bitrate_switching_1.SourceScoreLevel.Low, layer: sourceLayers[i], encoding: sourceLayers[i].encoding });
                    break;
                case 1:
                    qty.push({ level: bitrate_switching_1.SourceScoreLevel.Medium, layer: sourceLayers[i], encoding: sourceLayers[i].encoding });
                    break;
                case 2:
                    qty.push({ level: bitrate_switching_1.SourceScoreLevel.High, layer: sourceLayers[i], encoding: sourceLayers[i].encoding });
                    break;
                default:
            }
        }
    }
    const xcodeLayers = enc.map((e) => encodingToLayer(e)).filter((e) => !e.isSource);
    switch (xcodeLayers.length) {
        case 0:
            break;
        case 1:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Medium,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
        case 2:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Low,
                layer: encodingToLayer(xcodeLayers[1]),
                encoding: xcodeLayers[1].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.High,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
        case 3:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Low,
                layer: encodingToLayer(xcodeLayers[2]),
                encoding: xcodeLayers[2].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Medium,
                layer: encodingToLayer(xcodeLayers[1]),
                encoding: xcodeLayers[1].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.High,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
        case 4:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Low,
                layer: encodingToLayer(xcodeLayers[3]),
                encoding: xcodeLayers[3].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumLow,
                layer: encodingToLayer(xcodeLayers[2]),
                encoding: xcodeLayers[2].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumHigh,
                layer: encodingToLayer(xcodeLayers[1]),
                encoding: xcodeLayers[1].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.High,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
        case 5:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Low,
                layer: encodingToLayer(xcodeLayers[4]),
                encoding: xcodeLayers[4].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumLow,
                layer: encodingToLayer(xcodeLayers[3]),
                encoding: xcodeLayers[3].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Medium,
                layer: encodingToLayer(xcodeLayers[2]),
                encoding: xcodeLayers[2].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumHigh,
                layer: encodingToLayer(xcodeLayers[1]),
                encoding: xcodeLayers[1].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.High,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
        case 6:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Lowest,
                layer: encodingToLayer(xcodeLayers[5]),
                encoding: xcodeLayers[5].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Low,
                layer: encodingToLayer(xcodeLayers[4]),
                encoding: xcodeLayers[4].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumLow,
                layer: encodingToLayer(xcodeLayers[3]),
                encoding: xcodeLayers[3].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumHigh,
                layer: encodingToLayer(xcodeLayers[2]),
                encoding: xcodeLayers[2].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.High,
                layer: encodingToLayer(xcodeLayers[1]),
                encoding: xcodeLayers[1].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Highest,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
        default:
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Lowest,
                layer: encodingToLayer(xcodeLayers[6]),
                encoding: xcodeLayers[6].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Low,
                layer: encodingToLayer(xcodeLayers[5]),
                encoding: xcodeLayers[5].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumLow,
                layer: encodingToLayer(xcodeLayers[4]),
                encoding: xcodeLayers[4].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Medium,
                layer: encodingToLayer(xcodeLayers[3]),
                encoding: xcodeLayers[3].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.MediumHigh,
                layer: encodingToLayer(xcodeLayers[2]),
                encoding: xcodeLayers[2].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.High,
                layer: encodingToLayer(xcodeLayers[1]),
                encoding: xcodeLayers[1].encoding,
            });
            qty.push({
                level: bitrate_switching_1.TranscodeScoreLevel.Highest,
                layer: encodingToLayer(xcodeLayers[0]),
                encoding: xcodeLayers[0].encoding,
            });
            break;
    }
    if (player != null && (player instanceof hlsjs_1.HlsJsPlayer || player instanceof native_hls_1.NativeHlsPlayer)) {
        qty.push({
            level: bitrate_switching_1.AutoQualityLevel.Auto,
        });
    }
    return qty;
}
exports.ERRORS = {
    BAD_INPUT: "bad-input",
    DRIVER_NOT_SUPPORTED: "driver-not-supported",
    ELEMENT_REQUIRED: "element-required",
    EMBED_SWF_FAILED: "embedding-flash-swf-failed",
    GET_USER_MEDIA_FAILED: "get-user-media-failed",
    HTTP_SERVER_UNEXPECTED_RESPONSE: "http-server-unexpected-response",
    HTTP_SERVER_UNAUTHORIZED: "http-server-unauthorized",
    HTTP_SERVER_FORBIDDEN: "http-server-forbidden",
    HTTP_SERVER_INTERNAL_ERROR: "http-server-internal-error",
    HTTP_SERVER_NOT_FOUND: "http-server-not-found",
    MANIFEST: "http-response",
    INVALID_CONTROLS: "invalid-controls-parent",
    INVALID_MEDIA_URL: "invalid-media-url",
    INVALID_POPOUT_URL: "invalid-popout-url",
    INVALID_EL: "invalid-element",
    WS_NETWORK_ERROR: "websocket-network-error",
    NETWORK_ERROR: "network-error",
    NO_DRIVERS: "no-valid-drivers",
    PLAYBACK_ERROR: "playback-error",
    UNKNOWN_DRIVER: "unknown-driver",
    UNKNOWN_ERROR: "unknown-error",
    UNRECOGNIZED_DRIVER: "unrecognized-driver",
    USER_REQUIRED: "user-required",
    INVALD_BITRATE: "invalid-bitrate",
    HLSJS_NOT_LOADED: "hlsjs-not-loaded",
};
function isFatalError(err) {
    if (err && typeof err === "object" && "fatal" in err) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return err.fatal === true;
    }
    return false;
}
function nextScore(score) {
    switch (score) {
        case bitrate_switching_1.SourceScoreLevel.Low:
            return bitrate_switching_1.SourceScoreLevel.Medium;
        case bitrate_switching_1.SourceScoreLevel.Medium:
            return bitrate_switching_1.SourceScoreLevel.High;
        case bitrate_switching_1.SourceScoreLevel.High:
            return null;
        case bitrate_switching_1.TranscodeScoreLevel.Lowest:
            return bitrate_switching_1.TranscodeScoreLevel.Low;
        case bitrate_switching_1.TranscodeScoreLevel.Low:
            return bitrate_switching_1.TranscodeScoreLevel.MediumLow;
        case bitrate_switching_1.TranscodeScoreLevel.MediumLow:
            return bitrate_switching_1.TranscodeScoreLevel.Medium;
        case bitrate_switching_1.TranscodeScoreLevel.Medium:
            return bitrate_switching_1.TranscodeScoreLevel.MediumHigh;
        case bitrate_switching_1.TranscodeScoreLevel.MediumHigh:
            return bitrate_switching_1.TranscodeScoreLevel.High;
        case bitrate_switching_1.TranscodeScoreLevel.High:
            return bitrate_switching_1.TranscodeScoreLevel.Highest;
        default:
            return null;
    }
}
function prevScore(score) {
    switch (score) {
        case bitrate_switching_1.SourceScoreLevel.High:
            return bitrate_switching_1.SourceScoreLevel.Medium;
        case bitrate_switching_1.SourceScoreLevel.Medium:
            return bitrate_switching_1.SourceScoreLevel.Low;
        case bitrate_switching_1.SourceScoreLevel.Low:
            return null;
        case bitrate_switching_1.TranscodeScoreLevel.Highest:
            return bitrate_switching_1.TranscodeScoreLevel.High;
        case bitrate_switching_1.TranscodeScoreLevel.High:
            return bitrate_switching_1.TranscodeScoreLevel.MediumHigh;
        case bitrate_switching_1.TranscodeScoreLevel.MediumHigh:
            return bitrate_switching_1.TranscodeScoreLevel.Medium;
        case bitrate_switching_1.TranscodeScoreLevel.Medium:
            return bitrate_switching_1.TranscodeScoreLevel.MediumLow;
        case bitrate_switching_1.TranscodeScoreLevel.MediumLow:
            return bitrate_switching_1.TranscodeScoreLevel.Low;
        case bitrate_switching_1.TranscodeScoreLevel.Low:
            return bitrate_switching_1.TranscodeScoreLevel.Lowest;
        default:
            return null;
    }
}
/**
 * Find any closes to `score` quality. Always return some quality for non-empty `qualities` array
 */
function findClosestQuality(score, qualities) {
    if (qualities.length === 0) {
        return null;
    }
    if (score === bitrate_switching_1.AutoQualityLevel.Auto) {
        return { level: score };
    }
    let closestScore;
    const mapQualities = Object.fromEntries(qualities.map((q) => [q.level, q]));
    // go down from better quality to lower
    closestScore = score;
    while (closestScore != null && mapQualities[closestScore] == null) {
        closestScore = prevScore(closestScore);
    }
    if (closestScore == null) {
        // if still didn't find anything then go up
        closestScore = score;
        while (closestScore != null && mapQualities[closestScore] == null) {
            closestScore = nextScore(closestScore);
        }
    }
    if (closestScore != null) {
        return mapQualities[closestScore];
    }
    return null;
}
function equalQualities(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (a[i].level !== b[i].level) {
            return false;
        }
    }
    return true;
}
function dataProperties(data) {
    return { details: data.details, fatal: data.fatal, type: data.type, url: data.url };
}
exports.lowPowerModeMsg = "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.";
function isInLowPowerMode(err) {
    return (adapter_1.device.isIosDevice && err instanceof Error && err.name === "NotAllowedError" && err.message === exports.lowPowerModeMsg);
}
function attachVideoElement(el) {
    // return new Proxy(el, new MediaElementSupervisor());
    return el;
}
//# sourceMappingURL=helper.js.map